import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAddPage = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 21H7c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h10c1.105 0 2 .895 2 2v6M18 15v6M18 18h-3m3 0h3"
    />
  </svg>
);
export default SvgAddPage;
